import { useState, useEffect } from 'react';
import '../Proxy.css';

function ModalUrl({ isOpen, onClose, onSave, initialData }) {
  const [url, setUrl] = useState(initialData?.url || '');
  const [description, setDescription] = useState(initialData?.description || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setUrl(initialData?.url || '');
    setDescription(initialData?.description || '');
  }, [initialData, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onSave({ url, description });
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>{initialData ? 'Editar URL' : 'Adicionar Nova URL'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>URL</label>
            <input type="url" value={url} onChange={e => setUrl(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Descrição</label>
            <input type="text" value={description} onChange={e => setDescription(e.target.value)} />
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="button-cancel">Cancelar</button>
            <button type="submit" className="button-save" disabled={loading}>
              {loading ? 'Salvando...' : (initialData ? 'Salvar Alterações' : 'Adicionar URL')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalUrl;
